import React, { useState } from "react";
import PropTypes from "prop-types";
import { withErrorBoundary } from "react-error-boundary";
import ErrorComponent from "components/common/ErrorComponent";
import { FormControl, MenuItem, Select } from "@mui/material";
import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import { dataStatusRevenue, revenueStatus } from "constants/constants";
import { useKanban } from "components/kanban/kanban-context";

const SelectStatusPlan = ({valueStatus = 1}) => {
	const { setData, data, handleChangeStatusRevenue } = useKanban();
	const handleConditionalValue = value => {
		if (value == revenueStatus.DANGTHUCHIEN) return "#3644F7";
		if (value == revenueStatus.THUTRONGTUAN) return "#F79E36";
		if (value == revenueStatus.DATHU) return "#26B99A";
		if (value == revenueStatus.THUTRONGTHANG) return "#F73936";
		if (value == revenueStatus.SAPDONG) return "#0C9A3C";
	};
	const SelectInput = styled(InputBase)(({ color_status }) => ({
		"&": { backgroundColor: "red" },
		"& .MuiInputBase-input": {
			backgroundColor: handleConditionalValue(color_status),
			height: "1.1458333333rem !important",
			padding: "0px 0.625rem",
			color: "white",
			fontWeight: "400",
			fontSize: "0.677rem",
			display: "flex",
			alignItems: "center",
			lineHeight: 1,
		},
		".MuiMenu-list": {
			fontSize: "0.677rem",
			fontWeight: "400",
			color: "black",
		},
	}));
	const [value, setValue] = useState(valueStatus);
	const handleChangeValue = e => {
		setValue(e.target.value);
		handleChangeStatusRevenue(data.id, e.target.value)
	};
	return (
		<>
			<FormControl variant='standard' sx={{ minWidth: "6.666666rem" }}>
				<Select
					id='dropdownRevenuePlan'
					value={value}
					onChange={handleChangeValue}
					MenuProps={{ classes: { root: "dropdown-revenue-plan" } }}
					input={<SelectInput color_status={value}></SelectInput>}>
					{dataStatusRevenue &&
						dataStatusRevenue.length &&
						dataStatusRevenue.map((item, index) => (
							<MenuItem
								key={`dropdown-${index}`}
								value={Number(item.value)}>
								{item.name}
							</MenuItem>
						))}
				</Select>
			</FormControl>
		</>
	);
};

SelectStatusPlan.propTypes = {};
export default withErrorBoundary(SelectStatusPlan, {
	FallbackComponent: ErrorComponent,
});
